/**
 * Stops the browser Back button from replaying /api/auth/callback?code=...
 *
 * After a successful or failed OAuth callback, the user lands on one of
 * /auth/select-producer, /auth/no-producer, or /auth/error. The previous
 * history entry is the consumed callback URL — pressing Back re-issues
 * GET /api/auth/callback with a single-use code, which Cognito (or the
 * API's CSRF state check) rejects with its own error page.
 *
 * Replace the current entry with the SPA root and intercept popstate so
 * Back lands on / instead of the consumed callback URL.
 */

import { useEffect } from 'react';

export function useReplaceCallbackHistory(currentPath: string): void {
    useEffect(() => {
        // Preserve the current query string (e.g. ?from=idp on /auth/error)
        // so a refresh after the history rewrite still sees the marker.
        const targetUrl = `${currentPath}${window.location.search}`;
        window.history.replaceState(null, '', '/');
        window.history.pushState(null, '', targetUrl);
        const onPop = (): void => {
            window.location.replace('/');
        };
        window.addEventListener('popstate', onPop);
        return () => window.removeEventListener('popstate', onPop);
    }, [currentPath]);
}
